/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Arena-specific scoring mode (what's active for Arena challenges)
 * @export
 */
export const ArenaScoringMode = {
    AUTO_ONLY: 'AUTO_ONLY',
    MANUAL_ONLY: 'MANUAL_ONLY',
    AUTO_WITH_MANUAL_FALLBACK: 'AUTO_WITH_MANUAL_FALLBACK'
} as const;
export type ArenaScoringMode = typeof ArenaScoringMode[keyof typeof ArenaScoringMode];


export function instanceOfArenaScoringMode(value: any): boolean {
    for (const key in ArenaScoringMode) {
        if (Object.prototype.hasOwnProperty.call(ArenaScoringMode, key)) {
            if (ArenaScoringMode[key as keyof typeof ArenaScoringMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ArenaScoringModeFromJSON(json: any): ArenaScoringMode {
    return ArenaScoringModeFromJSONTyped(json, false);
}

export function ArenaScoringModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArenaScoringMode {
    return json as ArenaScoringMode;
}

export function ArenaScoringModeToJSON(value?: ArenaScoringMode | null): any {
    return value as any;
}

export function ArenaScoringModeToJSONTyped(value: any, ignoreDiscriminator: boolean): ArenaScoringMode {
    return value as ArenaScoringMode;
}

